/**
 * @generated SignedSource<<e169afa4c66cb2f5f1caffb48ed028e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingTab_storyTellingTab$data = {
  readonly smallImage: string | null;
  readonly mainImage: string | null;
  readonly mainVideo: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingText_storyTellingTab" | "PdpSharedStorytellingMainMedia_storyTellingTab" | "PdpSharedStorytellingShopAllLink_storyTellingTab">;
  readonly " $fragmentType": "PdpRespStorytellingTab_storyTellingTab";
};
export type PdpRespStorytellingTab_storyTellingTab$key = {
  readonly " $data"?: PdpRespStorytellingTab_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingTab_storyTellingTab",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespStorytellingText_storyTellingTab"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingMainMedia_storyTellingTab"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingShopAllLink_storyTellingTab"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainVideo",
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "420a2e0c415d302d9d6a0e33b4d0cbe9";

export default node;
